export const error = (state) => state.error;
export const isLoading = (state) => state.isLoading;
export const items = (state) => state.items;
export const item = (state) => state.item;
export const catchedTypesGen1 = (state) => state.catchedTypesGen1;
export const catchedTypesAlola = (state) => state.catchedTypesAlola;
